export default __webpack_public_path__ + "static/media/BuzzFeed.e4c80d9f.svg";